import axios from 'axios';
import { removeItem, setItem } from '../../features/authentication/utils/handleLocalStorage';

const API_URL = import.meta.env.VITE_TOKEN_API_URL;
const LOGIN_URL = import.meta.env.VITE_LOGIN_URL;

export const exchangeCodeForToken = async (code: string) => {
  const existingToken = localStorage.getItem('token')?.replace(/(^"|"$)/g, "");

  if (existingToken) {
    return existingToken;
  }

  const params = new URLSearchParams();
  params.append("grant_type", "authorization_code");
  params.append("code", code);
  params.append("redirect_uri", import.meta.env.VITE_OAUTH_REDIRECT_URI);

  const basicAuth = btoa(
    `${import.meta.env.VITE_CLIENT_ID}:${import.meta.env.VITE_CLIENT_SECRET}`
  );

  try {
    const response = await axios.post(API_URL, params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Basic ${basicAuth}`,
      },
    });

    const token = response.data.access_token;

    if (token) {
      setItem("token", token);
      return token;
    } else {
      throw new Error("❌ No se recibió un token válido");
    }
  } catch (error) {
    console.error("❌ Error obteniendo el token:", error);
    if (axios.isAxiosError(error) && error.response?.status === 400) {
      removeItem("token");
      removeItem("oauthCodeProcessed");
      window.location.href = LOGIN_URL;
    }
    throw new Error("Failed to obtain token");
  }
};
